import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'YOUR_API_KEY',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'YOUR_AUTH_DOMAIN',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'YOUR_PROJECT_ID',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'YOUR_STORAGE_BUCKET',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'YOUR_MESSAGING_SENDER_ID',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'YOUR_APP_ID',
};

if (firebaseConfig.apiKey === 'YOUR_API_KEY') {
  console.warn('⚠️ Firebase no está configurado. Ver archivo .env.local');
}

const app = initializeApp(firebaseConfig);

/**
 * App Check — exige que las peticiones vengan de esta aplicación, no de un
 * script con la API key copiada del bundle (la key web es pública por diseño).
 *
 * Queda inactivo mientras no exista VITE_APPCHECK_SITE_KEY, así que no rompe
 * nada hasta que se cree la clave reCAPTCHA v3 en la consola de Firebase.
 * Debe inicializarse ANTES de usar Firestore/Storage.
 *
 * Pasos para activarlo:
 *   1. Firebase Console → App Check → registrar la app web con reCAPTCHA v3.
 *   2. Copiar la clave de sitio a VITE_APPCHECK_SITE_KEY en .env.local.
 *   3. Dejarlo en modo "métricas" una semana antes de forzar el cumplimiento.
 */
const appCheckSiteKey = import.meta.env.VITE_APPCHECK_SITE_KEY;
if (appCheckSiteKey) {
  // Token de depuración para desarrollo local (no funciona en producción)
  if (import.meta.env.DEV && import.meta.env.VITE_APPCHECK_DEBUG_TOKEN) {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = import.meta.env.VITE_APPCHECK_DEBUG_TOKEN;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (import.meta.env.PROD) {
  console.warn('⚠️ App Check no configurado — la API key es utilizable desde fuera de la app');
}

export const auth = getAuth(app);

// Firestore con persistencia offline (IndexedDB)
// - Funciona offline: lee/escribe local, sincroniza al volver internet
// - Multi-tab: sincroniza entre pestañas abiertas
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export const storage = getStorage(app);

export default app;
